export default __webpack_public_path__ + "static/loja-5-0d3e9479f70a076ff01588206724ebfa.png";